// Shared constants for transactions page
export const ENTITY_TYPE_LABELS = {
  P: { label: "Individual", color: "bg-blue-100 text-blue-800" },
  C: { label: "Company", color: "bg-purple-100 text-purple-800" },
  F: { label: "Firm", color: "bg-orange-100 text-orange-800" },
  H: { label: "HUF", color: "bg-cyan-100 text-cyan-800" },
  A: { label: "AOP", color: "bg-teal-100 text-teal-800" },
  T: { label: "Trust", color: "bg-indigo-100 text-indigo-800" },
  B: { label: "BOI", color: "bg-pink-100 text-pink-800" },
  G: { label: "Govt", color: "bg-green-100 text-green-800" },
  J: { label: "AJP", color: "bg-yellow-100 text-yellow-800" },
  L: { label: "Local Auth", color: "bg-red-100 text-red-800" },
};

export const getEntityTypeFromPAN = (pan) => {
  if (!pan || pan.length < 4) return null;
  const code = pan.charAt(3).toUpperCase();
  return ENTITY_TYPE_LABELS[code] || null;
};

export const ALL_SECTIONS = [
  { section: "194A", description: "Interest" },
  { section: "194B", description: "Lottery" },
  { section: "194C", description: "Contractors" },
  { section: "194D", description: "Insurance Commission" },
  { section: "194DA", description: "Life Insurance" },
  { section: "194H", description: "Commission" },
  { section: "194I", description: "Rent" },
  { section: "194I(a)", description: "Rent P&M 2%" },
  { section: "194I(b)", description: "Rent Building 10%" },
  { section: "194IA", description: "Property Transfer" },
  { section: "194IB", description: "Rent by Individual" },
  { section: "194J", description: "Professional" },
  { section: "194K", description: "Mutual Fund" },
  { section: "194N", description: "Cash Withdrawal" },
  { section: "194O", description: "E-commerce" },
  { section: "194Q", description: "Purchase of Goods" },
  { section: "194R", description: "Benefits/Perquisites" },
  { section: "194S", description: "Virtual Digital Assets" },
  { section: "194T", description: "Payment to Partners" },
  { section: "195", description: "Non-Resident" },
  { section: "206C(1)", description: "TCS Sales" },
  { section: "206C(1F)", description: "TCS Motor Vehicle" },
  { section: "206C(1G)", description: "TCS Overseas Tour" },
  { section: "206C(1H)", description: "TCS Sale of Goods" },
  { section: "206CA", description: "TCS Alcoholic Liquor" },
  { section: "206CB", description: "TCS Timber" },
  { section: "206CC", description: "TCS Scrap" },
  { section: "206CD", description: "TCS Minerals" },
];

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(amount || 0);
